// Etapas oferecidas no "Mover para etapa" do card: todas do funil, na ordem
// das colunas, menos a etapa onde o card já está.
export const stagesForMoveMenu = (stages, currentStage) =>
  Object.entries(stages || {})
    .filter(([id]) => String(id) !== String(currentStage ?? ''))
    .map(([id, stage]) => ({
      id,
      name: stage?.name || id,
      color: stage?.color || 'rgb(var(--slate-9))',
      position: parseInt(stage?.position, 10) || 0,
    }))
    .sort((a, b) => a.position - b.position);
